import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import MusicPreviewBtn, {
  MusicPreviewBtnDisable,
} from '../../../../components/music/MusicPreviewBtn';
import {IDemoStingerMessageProps} from '../../../../dto/demoStingerFulfilment.dto';
type Props = {
  partnerStinger: IDemoStingerMessageProps[];
};
const DemoPartnerStinger = ({partnerStinger}: Props) => {
  return (
    <Box>
      <Typography variant='h4'> Partner Stinger</Typography>
      <TableContainer className='overflow-auto scrollbar h-full max-h-560 mb-2'>
        <Table
          sx={{
            '.MuiTableCell-root, .MuiTableRow-root': {
              padding: '6px 0',
            },
          }}>
          <TableHead>
            <TableRow>
              <TableCell className='text-white-50 '>Name</TableCell>
              <TableCell className='text-white-50 w-120'>File</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {partnerStinger.map(val => (
              <TableRow key={val.id}>
                <TableCell>{val.name}</TableCell>
                <TableCell>
                  {val.file_url ? (
                    <MusicPreviewBtn
                      id={val.id}
                      url={val.file_url}
                      track_name={val.name}
                      track_artist={val.name}
                    />
                  ) : (
                    <MusicPreviewBtnDisable />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default DemoPartnerStinger;
